export default {"src":"/_next/static/media/EHACare-logo-black.ad336815.svg","height":41,"width":174};